<template>
    <div>
        <v-card
            v-if="!isFile"
            class="fill-height"
            :class="{ 'grey lighten-2': dragover }"
            :disabled="readOnly"
            @drop.prevent="onDrop"
            @dragover.prevent="dragover = true"
            @dragenter.prevent="dragover = true"
            @dragleave.prevent="dragover = false"
            @click="clickInputFile"
        >
            <v-card-title class="mb-3">
                {{$vuetify.lang.t('$vuetify.utc.fileCard.filestorage')}} 
            </v-card-title>
            <v-card-text>
                <input id="fileInput" type="file" @change="onFileSelected" style="display:none">
                <v-row class="d-flex flex-column" dense align="center" justify="center">
                    <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">mdi-cloud-upload</v-icon>
                    <p>
                        {{$vuetify.lang.t('$vuetify.utc.fileCard.hereitisthestoragespaceforonedocumentspecifictothisutctohelpyouspotoridentifyit')}}
                        
                    </p>
                    <p v-if="uploadedFile == null"> {{$vuetify.lang.t('$vuetify.utc.fileCard.dropyourfileorclickhere')}} (JPEG, PNG, PDF)</p>
                </v-row>
                <v-list-item v-if="uploadedFile != null">
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ uploadedFile.name }}
                            <span class="ml-3 text--secondary">{{ uploadedFile.size }} bytes</span>
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn @click.stop="removeFile" icon>
                            <v-icon color="grey"> mdi-close-circle </v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-card-text>
            <v-card-actions>
                <v-row class="mb-3" justify="center">
                    <v-btn :class="uploadedFile === null ? '' : 'gradient-wintech'" @click.stop="submit" :disabled="uploadedFile === null">
                        <v-icon left>mdi-upload</v-icon>
                        {{$vuetify.lang.t('$vuetify.utc.fileCard.uploadthisdocument')}}
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card v-else class="fill-height">
            <v-card-title class="mb-4">
                File storage
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <a :href="utcInfos.url" target="_blank">
                        <v-img v-if="isPDF" src="@/assets/pdf.png" width="210px"></v-img>
                        <v-img v-else :src="utcInfos.url" width="280px"></v-img>
                    </a>
                </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn class="gradient-wintech" @click="downloadFile">
                    <v-icon left>mdi-download</v-icon>
                    {{$vuetify.lang.t('$vuetify.utc.fileCard.download')}}
                </v-btn>
                <v-btn color="red" :disabled="readOnly" @click="deleteFile">
                    <v-icon left>mdi-delete</v-icon>
                    {{$vuetify.lang.t('$vuetify.utc.fileCard.delete')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';

    export default {
        name: "FileCard",
        data() {
            return {
                dragover: false,
                uploadedFile: null,
            }
        },
        props: {
            utcInfos: Object,
        },
        computed: {
            ...mapGetters({ user: 'StateUser' }),
            readOnly() {
                return ['EXPLOITATION', 'ADMINISTRATION'].indexOf(this.user.role) === -1
            },
            isFile() {
                return this.utcInfos.url !== null
            },
            isPDF() {
                return this.utcInfos.blob.type === 'application/pdf'
            }
        },
        methods: {
            downloadFile() {
                const link = document.createElement('a');
                link.href = this.utcInfos.url;
                const ext = this.utcInfos.blob.type.split('/')[1];
                link.download = '' + this.utcInfos.serialnb + '.' + ext;
                document.body.appendChild(link);
                link.dispatchEvent(
                    new MouseEvent('click', { 
                        bubbles: true, 
                        cancelable: true, 
                        view: window 
                    })
                );
                document.body.removeChild(link);
            },
            async deleteFile() {
                try {
                    const res = await axios.delete('utcs/'+ this.utcInfos.serialnb+'/'+this.user.orga+'/file');
                    if (res.status == 200) {
                        this.removeFile();
                        this.$emit('update:file', this.utcInfos.serialnb);
                    }
                } catch(err) {
                    console.error(err);
                }
            },
            clickInputFile() {
                document.getElementById("fileInput").click();
            },
            testFileFormat(file) {
                return (file.type === "image/png" || file.type === "image/jpeg" || file.type === "application/pdf" )
            },
            onFileSelected(event) {
                const file = event.target.files[0];
                if (this.testFileFormat(file)) {
                    this.removeFile();
                    this.uploadedFile = event.target.files[0];
                }
            },
            onDrop(event) {
                const file = event.dataTransfer.files[0];
                if (this.testFileFormat(file)) {
                    this.removeFile();
                    this.uploadedFile = event.dataTransfer.files[0];
                }
                this.dragover = false;
            },
            removeFile() {
                this.uploadedFile = null;
            },
            async submit() {
                var SNformatToFile = this.utcInfos.serialnb.replace(".", "")
                const fd = new FormData();
                fd.append('image', this.uploadedFile, this.uploadedFile.name)
                try {
                    const res = await axios.post('utcs/'+SNformatToFile+'/'+this.user.orga+'/file', fd)
                    if (res.status == 200) {
                        this.removeFile();
                        this.$emit('update:file', this.utcInfos.serialnb)
                    }
                } catch (error) {
                    console.error(error);
                }
            },
        }
    }
    
    
</script>